import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FlyoutOpeningData } from '../flyout-models';
import { Logger, LoggerFactory } from 'app/core/logger.service';
import { FlyoutService } from '../flyout.service';

@Component({
  selector: 'app-flyout-scores',
  templateUrl: './flyout-scores.component.html',
  styleUrls: ['./flyout-scores.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlyoutScoresComponent {
  private readonly logger: Logger;
  public expandedTab: string;
  @Input() public set flyoutOpeningData(openingData: FlyoutOpeningData) {
    this.expandedTab = openingData.expandedTab;
  }

  constructor(
    public readonly loggerFactory: LoggerFactory,
    public readonly flyoutService: FlyoutService,
  ) {
    this.logger = loggerFactory.get('FlyoutScoresComponent');
  }
}
